import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { IFrameContainer } from '../../UserDetails.styles';
import {
  CompanyDataDiv,
  SectionBox,
} from '../../../AdminRoutes/Admin/Companies/CompaniesHome/CompanyHome.styles';
import Certificate from './CertificateAdminGenerator.component';
import TertiaryButton from '../../../Components/Buttons/TertiaryButton/TertiaryButton.component';

const CertificateDetails = ({ c, user }) => {
  if (!c.date) return null;
  const downloadCert = () => {
    if (c?.certificateUrl) {
      const link = document.createElement('a');
      link.href = c.certificateUrl;
      link.download = `Certificate-${user.firstName}-${user.lastName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  return (
    <>
      <CompanyDataDiv>
        <SectionBox>
          <aside>
            <h3
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              Course Certificate
              {c?.certificateUrl?.length > 0 && (
                <TertiaryButton
                  span="Download Certificate"
                  functionName={downloadCert}
                />
                // <a
                //   style={{ color: 'var(--orange5)', marginBlock: '1rem' }}
                //   href={c?.certificateUrl}
                //   alt="course url"
                // >
                //   Download the certificate
                // </a>
              )}
            </h3>
            <IFrameContainer>
              {c?.certificateUrl ? (
                <Suspense fallback={<p>Loading certificate...</p>}>
                  <>
                    <iframe
                      src={`${c?.certificateUrl}#toolbar=0&view=FitH`}
                      title="course certificate"
                    />
                  </>
                </Suspense>
              ) : (
                <>
                  <p style={{ textAlign: 'center' }}>There is no certificate</p>
                  <Certificate
                    name={`${user?.firstName} ${user?.lastName}`}
                    course={c}
                    userId={user?._id}
                  />
                </>
              )}
            </IFrameContainer>
          </aside>
        </SectionBox>
      </CompanyDataDiv>
    </>
  );
};
CertificateDetails.propTypes = {
  c: PropTypes.shape({
    certificateUrl: PropTypes.string,
    date: PropTypes.string,
  }),
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    _id: PropTypes.string,
  }),
};
export default CertificateDetails;
